var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5215 25.4756C16.7293 23.68 15.3511 21.5145 14.4831 19.1306C14.0056 17.8273 14.4431 16.3956 15.4248 15.4139L16.0323 14.8073C16.1956 14.6436 16.3896 14.5138 16.6032 14.4252C16.8167 14.3366 17.0457 14.291 17.2769 14.291C17.5081 14.291 17.737 14.3366 17.9506 14.4252C18.1641 14.5138 18.3581 14.6436 18.5215 14.8073L19.944 16.2298C20.1076 16.3931 20.2374 16.5871 20.326 16.8007C20.4146 17.0142 20.4602 17.2432 20.4602 17.4744C20.4602 17.7056 20.4146 17.9345 20.326 18.1481C20.2374 18.3616 20.1076 18.5556 19.944 18.7189L19.594 19.0689C19.4539 19.209 19.3427 19.3753 19.2669 19.5583C19.1911 19.7413 19.1521 19.9375 19.1521 20.1356C19.1521 20.3337 19.1911 20.5299 19.2669 20.7129C19.3427 20.8959 19.4539 21.0622 19.594 21.2023L22.794 24.4031C22.934 24.5432 23.1003 24.6543 23.2833 24.7302C23.4664 24.806 23.6625 24.845 23.8606 24.845C24.0587 24.845 24.2549 24.806 24.4379 24.7302C24.6209 24.6543 24.7872 24.5432 24.9273 24.4031L25.2781 24.0531C25.4414 23.8895 25.6354 23.7596 25.849 23.671C26.0626 23.5824 26.2915 23.5368 26.5227 23.5368C26.7539 23.5368 26.9829 23.5824 27.1964 23.671C27.41 23.7596 27.604 23.8895 27.7673 24.0531L29.1898 25.4756C29.3534 25.6389 29.4833 25.8329 29.5719 26.0465C29.6605 26.26 29.7061 26.489 29.7061 26.7202C29.7061 26.9514 29.6605 27.1803 29.5719 27.3939C29.4833 27.6075 29.3534 27.8015 29.1898 27.9648L28.5831 28.5714C27.6015 29.5539 26.1698 29.9914 24.8665 29.5139C22.4826 28.646 20.3171 27.2678 18.5215 25.4756Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/phone1.978de3c012b2b0f18792db4e71a18432.svg";
export { ForwardRef as ReactComponent };